import { hhmmOf, minutesOf } from './agenda.js';
import { isValidHhmm } from './dates.js';

// Van/Tot in de afspraak-editor (tijdkiezer, DESIGN.md §8.W3b). Schuift Van, dan blijft de duur
// gelijk. Die duur is de bedoelde duur: 60 min bij een nieuwe afspraak, anders het laatste geldige
// paar dat de ouder zelf koos (Tot, duurknop, sjabloon) of dat er al stond. Een door 23:59
// ingekort paar telt nooit als duur (review c-reg r3: 23:00–23:59 gaf daarna elke Van + 59 min).
// Na een typfout in Van (het veld geeft dan "") rekent een verbeterde Van niet vanaf 00:00
// (review c-ux r1: Tot sprong naar 23:59). Getest in timeRange.test.ts en tijdkiezer.e2e.ts.

const LAST_MINUTE = 23 * 60 + 59;

/** Duur in minuten als Van en Tot allebei geldig zijn en Tot na Van ligt; anders null. */
export function validDuration(start: string, end: string): number | null {
  if (!isValidHhmm(start) || !isValidHhmm(end)) return null;
  const d = minutesOf(end) - minutesOf(start);
  return d > 0 ? d : null;
}

/**
 * Nieuwe Tot na een nieuwe Van, met de laatst bekende geldige duur. null = Tot niet aanraken
 * (Van ongeldig of geen bekende duur). `clamped`: de dag was te kort, Tot is ingekort tot 23:59.
 */
export function endAfterStartChange(
  nextStart: string,
  duration: number | null,
): { end: string; clamped: boolean } | null {
  if (!isValidHhmm(nextStart) || duration === null || duration <= 0) return null;
  const wanted = minutesOf(nextStart) + duration;
  return { end: hhmmOf(Math.min(wanted, LAST_MINUTE)), clamped: wanted > LAST_MINUTE };
}
